import { Checkbox, toast } from '@systemeio/ui'
import { TwoFactorInterface } from 'modules/profile/change-password/types/two-factor-interface'
import { FC, useState } from 'react'
import { AdminRolesEnum } from 'shared/enums/user-roles-enum'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

const manageTwoFactorAuthRoles = [
  AdminRolesEnum.support,
  AdminRolesEnum.admin,
  AdminRolesEnum.superAdmin,
]

const TwoFactorAuth: FC = () => {
  const { user, checkImpersonatorAdminRoles, checkAdminRoles, isSupportImpersonation } = useUser()
  const { t } = useLocoTranslation()
  const [isFetching, setIsFetching] = useState(false)
  const { fetcher: getFetcher } = useFetch<RequestMethodsEnum.get, TwoFactorInterface>({
    method: RequestMethodsEnum.get,
  })
  const { fetcher: postFetcher } = useFetch({
    method: RequestMethodsEnum.post,
  })

  const { data: twoFaData, mutate } = useSWR(() => user && '/api/dashboard/profile', getFetcher)

  const updateTwoFa = async () => {
    if (!twoFaData) return
    setIsFetching(true)
    await postFetcher(
      twoFaData.twoFactorAuthEnabled
        ? '/api/dashboard/profile/deactivate-2fa'
        : '/api/dashboard/profile/activate-2fa',
    )
    await mutate(data => data && { twoFactorAuthEnabled: !data.twoFactorAuthEnabled }, false)
    toast.success(
      twoFaData.twoFactorAuthEnabled
        ? t('dashboard.user_list.2fa.deactivated')
        : t('dashboard.user_list.2fa.activated'),
    )
    setIsFetching(false)
  }

  const canManage = isSupportImpersonation
    ? checkImpersonatorAdminRoles(manageTwoFactorAuthRoles)
    : !checkAdminRoles(manageTwoFactorAuthRoles)

  return canManage ? (
    <Checkbox
      value={twoFaData?.twoFactorAuthEnabled || false}
      onChange={updateTwoFa}
      isFetching={isFetching}
      disabled={!twoFaData || isFetching}
      label={t('dashboard.user_list.2fa.title')}
    />
  ) : null
}

export default TwoFactorAuth
